export default "__VITE_ASSET__MM1Md_6Y__"